import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { mapQueryResult } from "@/api/utils/mapQuery"
import { AccountService } from "@/services/AccountService"
import { ContactService } from "@/services/ContactService"

/*
  The gateway keys contacts on the core billing account id, but every caller
  holds an account number — so resolve the core id in front of the read, the
  same way getDirectDebitMandates and the bills handlers do. Keeping this in a
  handler is what lets all the existing account-number call sites stay as they
  are.
*/
export const getAccountContacts = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const contactsQuery = ContactService.getForAccount(coreIdQuery.data)

  queries.add(coreIdQuery)
  queries.add(contactsQuery)

  return queries.setData(contactsQuery.data).getAggregate()
}

export const getPrimaryContact = (accountNumber: string) =>
  mapQueryResult(getAccountContacts(accountNumber), (query) =>
    query.data.find((contact) => contact.juniferPrimaryContact),
  )

export const isCustomerDeceased = (accountNumber: string) =>
  mapQueryResult(
    getPrimaryContact(accountNumber),
    (query) => !!query.data?.isDeceased,
  )
